import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder text-dark" }, "Top 5 Cabang"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "5 Cabang terbaik dalam mendapatkan pasar berdasarkan jumlah client")
  ])
], -1)
const _hoisted_2 = { class: "card-body pt-5" }
const _hoisted_3 = { class: "symbol symbol-50px me-5" }
const _hoisted_4 = { class: "symbol-label" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex align-items-center flex-row-fluid flex-wrap" }
const _hoisted_7 = { class: "flex-grow-1 me-2" }
const _hoisted_8 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-6 fw-bolder"
}
const _hoisted_9 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_10 = { class: "badge badge-light fw-bolder my-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass([{ 'mb-7': _ctx.list.length - 1 !== index }, "d-flex align-items-sm-center"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createElementVNode("img", {
                src: item.image,
                class: "h-50 align-self-center",
                alt: ""
              }, null, 8, _hoisted_5)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, _toDisplayString(item.title), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(item.text), 1)
            ]),
            _createElementVNode("span", _hoisted_10, _toDisplayString(item.badge), 1)
          ])
        ], 2))
      }), 128))
    ])
  ], 2))
}